module.exports = __webpack_public_path__ + "static/sec11-shoe-water-9da4e6bd8146ef12e3549b19241eed81.png";